import React from "react";
import Menu from "../../components/Menu";
import More from '../../assets/img/mais.svg'
import Doctor from '../../assets/img/doctor-black.svg'
import Back from '../../assets/img/de-volta.svg'

import { Link } from 'react-router-dom'
import ListCardProfessionals from "../../components/ListCardProfessionals";
function Professionals() {
  const [search,setSearch] = React.useState("")
  const screenTela =
    <div className='screenContainer' style={{paddingRight:'0px'}}>
      <div className="row row-container">

        <h1 className="col-6 col-sm-6 col-lg-8 name-screen"> <img style={{ width: '40px' }} alt="svg" src={Doctor} /> <span className="name-screen-title name-screen-professionals " >Profissionais</span> </h1>
        <div className="col-6 col-sm-6 col-lg-4 name-search name-search-2">
          <input value={search} onChange={(value) =>{
            setSearch(value.target.value)
          }} type="text" placeholder="Pesquisar Profissional" className="form-control input-pesquisa" />
        </div>
          <ListCardProfessionals search={search} />
      </div>
      <Link to="/dashboard">
        <div className="button-back-list">
          <img alt="mais" src={Back} />
        </div>
      </Link>
      <Link to="add">
        <div className="button-add">
          <img alt="mais" src={More} />
        </div>
      </Link>
    </div>

  return (
    <Menu screen={screenTela} />
  )
}

export default Professionals;